import { OwnerParams } from 'shared/types';
import { Step } from './steps';

export interface VisitFormRouteParams extends OwnerParams {
  step: Step;
}
